<template>
    <div class="sider-wrap" v-if="!$route.meta.hidden && menuSyced">
        <div class="siderBar">
            <el-menu class="el-menu-vertical" background-color="#ff6464" text-color="#fff" active-text-color="#ffd04b"
                :unique-opened="true" :default-active="$route.meta.activeMenu ? $route.meta.activeMenu : $route.path"
                :router="false">
                <template v-for="(item, index) in basicMenu">
                    <!-- API接口不展示 -->
                    <div :key="item.showCode" v-show="showMenu.includes(index) && !['API接口'].includes(item.name)">
                        <el-menu-item v-if="!item.children || item.children.length === 0" :index="item.url"
                            @click="menuItemClick(item.url)" :title="item.name">
                            <span>{{ item.name }}</span>
                        </el-menu-item>
                        <el-submenu v-else :index="item.url">
                            <template slot="title">
                                <span :title="item.name">{{ item.name }}</span>
                            </template>
                            <template v-for="cItem in item.children">
                                <template v-if="noSidebarShow.includes(cItem.url)">
                                </template>
                                <!-- 授权验号需要是会员且消费满足一定条件才能展示出来 -->
                                <template v-else-if="cItem.name === '授权验号'">
                                    <el-menu-item v-if="!!+userData.is_authorize" :key="cItem.showCode" :index="cItem.url"
                                        :title="cItem.name" @click="menuItemClick(cItem.url)">
                                        {{ cItem.name }}
                                    </el-menu-item>
                                </template>
                                <el-menu-item v-else :key="cItem.showCode" :index="cItem.url" :title="cItem.name"
                                    @click="menuItemClick(cItem.url)">
                                    {{ cItem.name }}
                                </el-menu-item>
                            </template>
                        </el-submenu>
                    </div>
                </template>
            </el-menu>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState(["configData", "userData", "siderBarCate", "basicMenu", "menuSyced"]),
        showMenu() {
            // return [0, 1, 2, 3, 4, 5] // 展示全部的菜单
            // 修改这里会影响到礼品发货下单页面的菜单展示
            if (isNaN(this.siderBarCate)) {
                return [];
            } else {
                let siderBarCate = []
                for (let i = 0; i < this.basicMenu.length; i++) {
                    siderBarCate.push(i)
                }
                return siderBarCate // 菜单新增了一个大项, 则这里的数组项新增 1 个, 且内容一次类推数字 + 1
            }
        },
        isMainSite() {
            return !(process.env.NODE_ENV === "production" && process.env.VUE_APP_MODE === "clone");
        },
    },
    data() {
        return {
            subNavList: [
                {
                    href: "/home",
                    icon: "el-icon-menu",
                    name: "验号中心",
                    children: [
                        {
                            href: "/ww-label-weight",
                            name: "旺旺标签权重",
                        },
                        {
                            href: "/home",
                            name: "旺旺照妖镜",
                        },
                        {
                            href: "/weightpush",
                            name: "搜索权重推送",
                        },
                        {
                            href: "/keyRank",
                            name: "淘宝排名查询",
                        },
                        {
                            href: "/tagSearch",
                            name: "淘宝号标签查询",
                        },
                        {
                            href: "/goodsAnalysis",
                            name: "竞品数据透析",
                        },
                        {
                            href: "/traceless",
                            name: "无痕做单",
                        },
                        {
                            href: "/validPicture",
                            name: "防P图验号",
                        },
                        {
                            href: "/transformData",
                            name: "指数换算",
                        },
                        {
                            href: "/tbguest",
                            name: "淘宝客订单检测",
                        },
                        {
                            href: "/checkNum/dsrCal",
                            name: "DSR智能计算器",
                        },
                        {
                            href: "/taokouling",
                            name: "淘口令生成",
                        },
                        {
                            href: "/appraise",
                            name: "宝贝评价分析",
                        },
                        {
                            href: "/lexicon",
                            name: "TOP20w词库",
                        },
                        {
                            href: "/lexRecommend",
                            name: "搜索下拉推荐词",
                        },
                        {
                            href: "/lexTaobaoTag",
                            name: "旺旺搜索词推荐",
                        },
                        {
                            href: "/checkAccount",
                            name: "大数据验号",
                        },
                        {
                            href: "/dy-check",
                            name: "抖音验号",
                        },
                        {
                            href: "/authCheck",
                            name: "授权验号",
                        },
                        {
                            href: "/taokit",
                            name: "免费工具箱",
                        },
                    ],
                },
                {
                    href: "/pause",
                    icon: "el-icon-s-platform",
                    name: "卡首屏",
                    children: [
                        {
                            href: "/checkNum/firstPause",
                            name: "关键词卡首屏",
                        },
                        {
                            href: "/checkNum/similarImport",
                            name: "找相似入口",
                        },
                        {
                            href: "/marking",
                            name: "旺旺强行打标",
                        },
                        {
                            href: "/tbmobile/guess",
                            name: "猜你喜欢",
                        },
                        {
                            href: "/dy-first-page",
                            name: "抖音卡首屏",
                        },
                        {
                            href: "/first-flow-dy/first-flow",
                            name: "抖音搜索卡首屏",
                        },
                        {
                            href: "/first-flow-dy/guess",
                            name: "抖音猜你喜欢",
                        },
                        {
                            href: "/pddScreen",
                            name: "拼多多打标",
                        },
                        {
                            href: "/first-flow-pdd/said-ok",
                            name: "大家都说好",
                        },
                        {
                            href: "/first-flow-albb",
                            name: "1688卡首屏",
                        },
                        {
                            href: "/first-flow-pdd/first-flow",
                            name: "拼多多卡首屏",
                        },
                        {
                            href: "/head_screen/recommend",
                            name: "卡首屏系列",
                        },
                    ],
                },
                {
                    href: "/tbmobile",
                    icon: "el-icon-mobile",
                    name: "手淘卡屏",
                    children: [
                        {
                            href: "/tbmobile/nicegoods",
                            name: "有好货",
                        },
                        {
                            href: "/tbmobile/dayshops",
                            name: "每日好店",
                        },
                        {
                            href: "/tbmobile/iFashion",
                            name: "iFashion",
                        },
                        {
                            href: "/tbmobile/robshop",
                            name: "淘抢购",
                        },
                        {
                            href: "/tbmobile/probaby",
                            name: "亲宝贝",
                        },
                        {
                            href: "/tbmobile/hbooth",
                            name: "首页钻展",
                        },
                        {
                            href: "/tbmobile/globalshop",
                            name: "全球购",
                        },
                        {
                            href: "/head_screen/life",
                            name: "生活研究所",
                        },
                        {
                            href: "/tbmobile/brand-undergarments",
                            name: "U先使用",
                        }
                    ],
                },
                {
                    href: "/monitor",
                    icon: "el-icon-s-platform",
                    name: "监控中心",
                    children: [
                        {
                            href: "/monitor/detail",
                            name: "单品详情",
                        },
                        {
                            href: "/monitor/competitive",
                            name: "竞品监控",
                        },
                        {
                            href: "/monitor/annual-fee",
                            name: "开通竞品监控",
                        },
                        {
                            href: "/monitor/record",
                            name: "历史记录",
                        },
                    ],
                },
                {
                    href: "/giftShop",
                    icon: "el-icon-s-platform",
                    name: "礼品发货",
                    children: [
                        {
                            href: "/store/list",
                            name: "商品列表",
                        },
                        {
                            href: "/store/orderList",
                            name: "订单列表",
                        },
                        {
                            href: "/store/package",
                            name: "包裹列表",
                        },
                    ],
                },
                {
                    href: "/flow",
                    icon: "el-icon-s-marketing",
                    name: "流量中心",
                    children: [
                        {
                            href: "/flow/taobao",
                            name: "淘宝流量提升",
                        },
                        {
                            href: "/flow/pdd",
                            name: "拼多多流量提升",
                        },
                        {
                            href: "/flow/jd",
                            name: "京东流量提升",
                        },
                        {
                            href: "/flow/dy",
                            name: "抖音流量提升",
                        },
                        {
                            href: "/flow/tasklist",
                            name: "任务列表",
                        },
                    ],
                },
                {
                    href: "/user",
                    icon: "el-icon-user-solid",
                    name: "用户中心",
                    children: [
                        {
                            href: "/personCenter",
                            name: "账户中心",
                        },
                        {
                            href: "/newsCenter",
                            name: "消息中心",
                        },
                        {
                            href: "/vip",
                            name: "开通会员",
                        },
                        {
                            href: "/promotion-manage",
                            name: "推广管理",
                        },
                        {
                            href: "/busQuery",
                            name: "业务查询",
                        },
                        {
                            href: "/recharge",
                            name: "充值记录",
                        },
                        {
                            href: "/childAccount",
                            name: "子账号管理",
                        },
                    ],
                },
            ],
            showSidebarRouter: [
                "/childAccount",
                "/head_screen/micro-details",
                "/head_screen/ask-everyone",
                "/head_screen/buy-ask-everyone",
                "/head_screen/first-order-discount",
                "/head_screen/farm",
                "/head_screen/wangwang",
                "/head_screen/other-shop",
                "/head_screen/other-fee",
                "/head_screen/black-box",
                "/head_screen/buyers-show",
                "/head_screen/daily-deals",
                "/head_screen/poly-cost-effective",
                "/head_screen/buy-page",
                "/head_screen/coins",
                "/head_screen/firstPause",
                "/head_screen/new-products",
                "/first-flow-dy/first-flow",
                "/first-flow-dy/guess",
                "/first-flow-pdd/said-ok",
                "/first-flow-pdd/first-flow"
            ], // 显示侧边栏的路由
            noSidebarShow: [
                "/tbmobile/iFashion",
                "/head_screen/life",
                "/head_screen/coins",
                "/tbmobile/globalshop",
                "/tbmobile/hbooth",
                "/head_screen/buy-page",
                "/head_screen/poly-cost-effective",
                "/head_screen/daily-deals",
                "/head_screen/buyers-show",
                "/head_screen/firstPause",
                "/head_screen/new-products",
                "/head_screen/black-box",
                "/head_screen/other-fee",
                "/head_screen/other-shop",
                "/head_screen/wangwang",
                "/head_screen/farm",
                "/head_screen/first-order-discount",
                "/head_screen/buy-ask-everyone",
                "/tbmobile/probaby",
                "/head_screen/ask-everyone",
                // 20240307
                "/tbmobile/tm-live",
                "/tbmobile/brand-undergarments",
                "/tbmobile/tnei-discover",
                "/tbmobile/tnei-recommandations",
                "/tbmobile/tmr-topic-cloud",
                "/tbmobile/tm-must-list",
                "/tbmobile/details-main-img",
                "/tbmobile/short-video-fullpage",
                "/tbmobile/tm-nice-price",
                "/tbmobile/tm-plt",
                "/tbmobile/tm-nice-goodies",
                "/tbmobile/tiny-black-box",
                "/tbmobile/guess-your-like-star",
                "/tbmobile/first-order-coupon",
                "/tbmobile/taobao-foodie",
                "/tbmobile/trend-play",
                "/tbmobile/holiday-guide",
                "/tbmobile/piece-house",
                "/tbmobile/my-cute-pets",
                "/tbmobile/cat-fresh-food",
                "/tbmobile/trend-woo",
                "/tbmobile/cool-planet",
                "/tbmobile/odp",
                "/tbmobile/global-purchase",
                "/tbmobile/tm-neighbor-goodies",
                "/tbmobile/tmall-international",
                "/tbmobile/tmall-luxury",
                "/tbmobile/tmall-apple-fans",
                "/tbmobile/tmall-list",
                "/tbmobile/tmall-creation",

                "/head_screen/everyday-low-price",
                "/head_screen/post-purchase-recommandations",
                "/head_screen/tb-good-price",
                "/head_screen/tnei-unclassified",
                "/head_screen/tnei-guess-like",
                "/head_screen/billions-subsidies",
                "/head_screen/car-life",
                "/head_screen/favorable-life",
                "/head_screen/domestic-electric-appliance",
                "/head_screen/trend-electric-digital",
                "/head_screen/deep-in-autumn",
                "/head_screen/tend-fun-festival",
                "/head_screen/fun-season",
                "/head_screen/dopamine",
                "/head_screen/pet-day",
                "/head_screen/ice-festival",
                "/head_screen/valentine-day",
                "/head_screen/hot-sale-shoes-boots",
                "/head_screen/live-dress",
                "/head_screen/spring-new",
                "/head_screen/global-trend",
                "/head_screen/global-discover",
                "/head_screen/international-self-support",
                "/head_screen/home-appliance",
                "/head_screen/home-improvement-goodies",
                "/head_screen/home-improvement-nice-price",
                "/head_screen/home-must-have",
                "/head_screen/home-enjoy-life",
                "/head_screen/fashion",
                "/head_screen/boutique-furniture",
                "/head_screen/quality-applicance",
                "/head_screen/sport-trend",
                "/head_screen/sport-goodies",
                "/head_screen/enjoy-nice-food",
                "/head_screen/beauty-toiletry",
                "/head_screen/mother-baby",
                "/head_screen/culture",
                "/head_screen/corporate-procurement",
                "/head_screen/corporate-culture",
                "/head_screen/publish-trend",
                "/head_screen/supper-item",
                "/head_screen/jewelry",
                "/head_screen/brand-ceremony",
                "/head_screen/woman-fashion",
                "/head_screen/subtlety-pet",
                "/head_screen/watch-eyeglasses",
                "/head_screen/health-life",
                "/head_screen/kitchenette",
                "/head_screen/pre-enjoy-trend",
                "/head_screen/bedding-home-decor",
                "/head_screen/spring-newest",
                "/head_screen/tmall-u-first",
                "/head_screen/tmall-market",
                "/head_screen/tmall-medicine",
                "/head_screen/brand-digital",
                "/head_screen/brand-jewelry",
                "/head_screen/brand-mother-baby",
                "/head_screen/brand-home-cleaner",
                "/head_screen/brand-personal-care",
                "/head_screen/brand-beauty",
                "/head_screen/brand-man-clothes",
                "/head_screen/brand-undergarments",
            ], // 不展示的路由
        };
    },
    watch: {
        $route(newValue, oldValue) {
            let activeFirstId;
            for (const firstMenu in this.basicMenu) {
                for (const key in this.basicMenu[firstMenu].children) {
                    // 如果路由在菜单内, 或者在白名单内, 则显示侧边栏
                    if (this.showSidebarRouter.includes(newValue.path) || newValue.path.includes(this.basicMenu[firstMenu].children[key].url) ||
                        this.basicMenu[firstMenu].children[key].url === newValue.meta.activeMenu) {
                        activeFirstId = firstMenu;
                    }
                }
            }
            this.$store.dispatch("setSiderBarCate", Number(activeFirstId));
        },
    },
    methods: {
        apiIndex(cItem) {
            let baseUrl = "http://doc.vv-tool.com";

            // 分站的文档地址
            if (!this.isMainSite && this.configData.proxy_info && this.configData.proxy_info.site_doc_host) {
                if (this.configData.proxy_info.site_doc_host.indexOf("//") > -1) {
                    baseUrl = this.configData.proxy_info.site_doc_host;
                } else {
                    baseUrl = `//${this.configData.proxy_info.site_doc_host}`;
                }
            }

            return `${baseUrl}${cItem.url}`
        },

        menuItemClick(url) {
            if (url.includes("//")) {
                window.open(url)
            } else {
                this.$router.push(url);
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.sider-wrap {
    width: 1315px;
    height: 1px;
    position: relative;
    margin: 0 auto;
}

@media only screen and (min-width: 1500px) {
    .sider-wrap {
        width: 1315px;
    }
}

.siderBar {
    position: absolute;
    top: 20px;
    width: 150px;
    left: 10px;
    border-radius: 10px;
    overflow: hidden;

    .el-submenu .el-menu-item {
        // padding: 0;
        min-width: auto;
        background: #a4a4a4 !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 10px;
        padding-left: 10px !important;
    }

    .el-menu-item.is-active {
        border-left: none;
        background: #ff2222 !important;
    }

    .el-menu-item:focus,
    .el-menu-item:hover {
        background-color: #ff2222 !important;
    }

    .el-menu-item {
        color: #fff !important;
    }

    .el-submenu__title i {
        color: #909399;
    }
}
</style>

<style lang="scss">
.siderBar {
    .el-submenu .el-menu-item {
        height: 36px;
        line-height: 36px;
        font-size: 14px;
    }

    .el-submenu__title i {
        color: #fff;
    }

    .el-submenu .el-menu {
        background: #a4a4a4 !important;
    }

    .el-submenu__title:focus,
    .el-submenu__title:hover {
        background-color: #ff6464 !important;
    }
}
</style>
